import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlicePipe } from '../core/pipes/slice.pipe';
import { DateFormatPipe } from '../core/pipes/date-format.pipe';

@NgModule({
  declarations: [SlicePipe, DateFormatPipe],
  imports: [CommonModule],
  exports: [SlicePipe, DateFormatPipe],
})
export class SharedModule {}
